import { render, staticRenderFns } from "./ShopTypeSelect.vue?vue&type=template&id=643714fc&scoped=true&"
import script from "./ShopTypeSelect.vue?vue&type=script&lang=js&"
export * from "./ShopTypeSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "643714fc",
  null
  
)

export default component.exports